module.exports = __webpack_public_path__ + "img/promo@2x.81c23b1e.png";